import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";

// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Nav } from "reactstrap";
import {
  BackgroundColorContext,
} from "contexts/BackgroundColorContext";

import constants from 'util/constans';
import { decode } from "util/base64";

function Sidebar(props) {
  const [modules, setModules] = useState([]); 

  const location = useLocation();
  const sidebarRef = React.useRef(null);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  useEffect(() => { 
    const _userinfoEncoded = localStorage.getItem(constants.userinfo);
    if(_userinfoEncoded) {
    try {
      const _userinfo = JSON.parse(decode(_userinfoEncoded));
      const _modules = _userinfo.modules
        ? String(_userinfo.modules).replace(/\s+/g, '').split(',').filter(Boolean)
        : [];
      setModules(_modules);
    } catch (error) {
      setModules([]);
    }
    }
    
   }, [props.userInfo]);

  React.useEffect(() => {
    let scrollbar = null;
    if (navigator.platform.indexOf("Win") > -1 && sidebarRef.current) {
      scrollbar = new PerfectScrollbar(sidebarRef.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    
    // Specify how to clean up after this effect:
    return function cleanup() {
      scrollbar?.destroy();
    };
  }, []);

  let { routes, logo } = props;
  const visibleRoutes = routes.filter((prop) => {
    if (prop.redirect) return false;
    if (prop.invisible) return false;
    if (prop.idText && !modules.includes(prop.idText)) return false;
    if (prop.idSep && !modules.includes(prop.idSep)) return false;
    return true;
  }).filter((prop, index, filteredRoutes) => {
    if (prop.type !== 'separator') return true;

    const previousRoute = filteredRoutes[index - 1];
    const nextRoute = filteredRoutes[index + 1];

    return previousRoute?.type !== 'separator' && nextRoute && nextRoute.type !== 'separator';
  });
  let logoImg = null;
  let logoText = null;
  if (logo !== undefined) {
    if (logo.outterLink !== undefined) {
      logoImg = (
        <a
          href={logo.outterLink}
          className="simple-text logo-mini"
          target="_blank"
          rel="noreferrer"
          onClick={props.toggleSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="react-logo" />
          </div>
        </a>
      );
      logoText = (
        <a
          href={logo.outterLink}
          className="simple-text logo-normal"
          target="_blank"
          rel="noreferrer"
          onClick={props.toggleSidebar}
        >
          {logo.text}
        </a>
      );
    } else {
      logoImg = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-mini"
          onClick={props.toggleSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="react-logo" />
          </div>
        </Link>
      );
      logoText = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-normal"
          onClick={props.toggleSidebar}
        >
          {logo.text}
        </Link>
      );
    }
  }
  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <div className="sidebar" data={color}>
          <div className="sidebar-wrapper" ref={sidebarRef}>
            {logoImg !== null || logoText !== null ? (
              <div className="logo">
                {logoImg}
                {logoText}
              </div>
            ) : null}
            <Nav>
              <li className="sidebar-collapse-item d-none d-lg-block">
                <button
                  type="button"
                  className="sidebar-collapse-button"
                  onClick={props.toggleSidebarCollapsed}
                  aria-label={props.sidebarCollapsed ? "Expandir menú lateral" : "Contraer menú lateral"}
                  aria-pressed={props.sidebarCollapsed}
                  title={props.sidebarCollapsed ? "" : ""}
                >
                  <i
                    className={`tim-icons ${props.sidebarCollapsed ? "icon-minimal-right" : "icon-minimal-left"}`}
                    aria-hidden="true"
                  />
                  <span></span>
                </button>
              </li>
              {visibleRoutes.map((prop, key) => {
                return prop.type == 'separator' ? (<li key={`separator-${key}`}><hr className="separator"></hr></li>) :  (
                  <li
                    className={
                      activeRoute(prop.layout + prop.path) + (prop.pro ? " active-pro" : "")
                    }
                    key={prop.layout + prop.path}
                  >
                    <NavLink
                      to={prop.layout + prop.path}
                      className="nav-link"
                      onClick={props.toggleSidebar}
                    >
                      <i className={prop.icon} />
                      <p title={prop.name} style={{textOverflow:'ellipsis', overflow:'hidden'}}>{prop.name}</p>
                    </NavLink>
                  </li>
                );
              })}
            </Nav>
          </div>
        </div>
      )}
    </BackgroundColorContext.Consumer>
  );
}

Sidebar.propTypes = {
  // if true, then instead of the routes[i].name, routes[i].rtlName will be rendered
  // insde the links of this component
  rtlActive: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the text of the logo
    text: PropTypes.node,
    // the image src of the logo
    imgSrc: PropTypes.string,
  }),
};

export default Sidebar;
